import { render, staticRenderFns } from "./add_supplier.vue?vue&type=template&id=62e62a13&scoped=true"
import script from "./add_supplier.vue?vue&type=script&lang=js"
export * from "./add_supplier.vue?vue&type=script&lang=js"
import style0 from "./add_supplier.vue?vue&type=style&index=0&id=62e62a13&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e62a13",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62e62a13')) {
      api.createRecord('62e62a13', component.options)
    } else {
      api.reload('62e62a13', component.options)
    }
    module.hot.accept("./add_supplier.vue?vue&type=template&id=62e62a13&scoped=true", function () {
      api.rerender('62e62a13', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/supplierManagement/add_supplier/add_supplier.vue"
export default component.exports